import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';
import { getAddOnsTotalFromPricingMetaData } from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';

export function getRoundedFullPaymentAmount(
  charter: Charter,
  promoAmount: number,
): string {
  return (
    charter.charterBaseFee +
    getAddOnsTotalFromPricingMetaData(charter.pricingMetaData, null, true) +
    charter.serviceTotal -
    charter.discountTotal -
    promoAmount
  ).toFixed(2);
}

export function getRoundedRemainingPaymentAmount(
  charter: Charter,
  promoAmount: number,
): string {
  return (
    charter.charterBaseFee +
    charter.serviceTotal -
    charter.discountTotal -
    promoAmount
  ).toFixed(2);
}

export function incrementBaseFeeForDefaultCrewAdditions(
  charter: Partial<Charter>,
  crew: any[],
  crewRate: VesselRate,
  crewRateCount: number,
  crewPrice: number,
  duration?: number,
) {
  if (!crewRate) {
    charter.charterBaseFee +=
      crew.length * (15 * (charter.duration ? charter.duration : duration));
  } else if (crew.length > crewRateCount) {
    charter.charterBaseFee += crewPrice * (crew.length - crewRateCount);
  }
}
